import { Dropdown, Space } from 'antd';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button as ButtonAtom } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';

export enum GroupBy {
  Project = 'project',
  ResponseDate = 'responseDate',
  Milestone = 'milestone',
  Customer = 'customer',
  Rating = 'rating',
}

const Button = styled(ButtonAtom)`
  margin-bottom: var(--spacing-03);
  &.ant-dropdown-open {
    background-color: var(--hover-color);
  }
`;

const StyledMenu = styled(Menu)`
  max-width: 13rem;
`;

interface GroupByMenuProps {
  defaultValue?: GroupBy;
  onChange: (key: GroupBy) => void;
  disabled?: boolean;
}

export const GroupByMenu: FC<GroupByMenuProps> = (props) => {
  const { onChange, defaultValue, disabled = false } = props;
  const [selected, setSelected] = useState(
    defaultValue || GroupBy.ResponseDate,
  );
  const handleOnSelect = ({ key }) => {
    setSelected(key);
    onChange(key as GroupBy);
  };

  return (
    <Dropdown
      disabled={disabled}
      overlay={
        <StyledMenu selectedKeys={[selected]}>
          <Menu.Header>
            <FormattedMessage id="group_by" />
          </Menu.Header>
          {Object.values(GroupBy).map((value) => (
            <Menu.Item key={value} onClick={handleOnSelect}>
              <FormattedMessage id={value} />
            </Menu.Item>
          ))}
        </StyledMenu>
      }
    >
      <Button disabled={disabled} size="middle" type="text">
        <Space size="small">
          <div>
            <FormattedMessage id="group_by" />:
          </div>
          <strong>
            <FormattedMessage id={selected} />
          </strong>
        </Space>
      </Button>
    </Dropdown>
  );
};
